import { render, staticRenderFns } from "./PageInputs.vue?vue&type=template&id=3dcbc6bf&"
import script from "./PageInputs.vue?vue&type=script&lang=ts&"
export * from "./PageInputs.vue?vue&type=script&lang=ts&"
import style0 from "./PageInputs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports